import React, { FC } from "react";
import {
  IconContainer,
  LoaderContainer,
  NotificationBadge,
  NotificationListContainer,
  Wrapper,
} from "./styled";
import Icon from "@icon-park/react/es/all";
import { InlineLoader } from "@ifgengineering/component-library";
import { useTheme } from "styled-components";
import { TNotification } from "@ifgengineering/client-notifications-sdk";
import EmptyState from "./EmptyState";
import NotificationList from "./NotificationList";

interface DesktopNotificationList {
  isOpen: boolean;
  anyPendingNotification: boolean;
  isLoading: boolean;
  notifications: TNotification[];
  setIsOpen: (setIsOpen: boolean) => void;
}

export const DesktopNotificationList: FC<DesktopNotificationList> = ({
  isOpen,
  notifications,
  isLoading,
  anyPendingNotification,
  setIsOpen,
}) => {
  const theme = useTheme();

  const renderContent = (notifications: TNotification[]) => {
    if (isLoading) {
      return (
        <NotificationListContainer>
          <LoaderContainer data-testid="notifications-loader">
            <InlineLoader size={30} thickness={3} />
          </LoaderContainer>
        </NotificationListContainer>
      );
    }

    const whatToShow = notifications.length ? (
      <NotificationList setShow={setIsOpen} notifications={notifications} />
    ) : (
      <EmptyState />
    );

    return <NotificationListContainer>{whatToShow}</NotificationListContainer>;
  };

  return (
    <Wrapper>
      <IconContainer onClick={() => setIsOpen(!isOpen)} highlight={isOpen}>
        {anyPendingNotification && <NotificationBadge />}
        <Icon
          type="Remind"
          fill={
            isOpen
              ? theme.colors.ui.icon.secondary
              : theme.colors.ui.icon.onColor
          }
          size="24"
        />
      </IconContainer>
      {isOpen && renderContent(notifications)}
    </Wrapper>
  );
};

export default DesktopNotificationList;
